/* unplugin-vue-components disabled */import { render } from "./box.vue?vue&type=template&id=47f02697&scoped=true"
import script from "./box.vue?vue&type=script&lang=js"
export * from "./box.vue?vue&type=script&lang=js"

import "./box.vue?vue&type=style&index=0&id=47f02697&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f02697"]])

export default __exports__